import { usePaymentsTable } from "Payment/Components/Tables/Hooks/usePaymentsTable";
import { Table } from "Shared/Components/Table";

export function AllPaymentsTab() {
	const tableOptions = usePaymentsTable();

	return <Table tableOptions={tableOptions} />;
}
